require('es6-shim');

import $ from 'jquery';
import settings from '../config/settings';
import ClientAnalytics from './analytics/ClientAnalytics';
import augmentArticle from './augmentation/augmentArticle';
import * as VisibilityEventUtils from './utils/VisibilityEventUtils';
import axios from './api/axiosNonAuth';
import {X_VUP_ORIGIN_PUBLISHER} from './api/consts';

// mark API requests originating in augmentation script as 'publisher' origin
axios.setVupOriginHttpHeader(X_VUP_ORIGIN_PUBLISHER);

$(() => initAugmentation());

export function initAugmentation() {
  window.VupAugment = window.VupAugment || {};
  if (!window.VupAugment.isInitialized) {
    window.VupAugment.isInitialized = true;

    loadCss(settings.widget.snippet.styleUrl);
    loadCss('https://fonts.googleapis.com/css?family=Lato&subset=latin,latin-ext');

    startAnalytics();

    VisibilityEventUtils.initVisibilityChangeEvents();
    runAugmentation();
    listenForSPALocationChanges();
  }
}

function isAugmented() {
  window.VupAugment = window.VupAugment || {};
  return window.VupAugment.isAugmented;
}

function setAugmentedFlag(value) {
  window.VupAugment = window.VupAugment || {};
  window.VupAugment.isAugmented = value;
}

function runAugmentation() {
  if (!isAugmented()) {
    setAugmentedFlag(true);

    return augmentArticle()
      .then(() => {
        setTimeout(() => VisibilityEventUtils.sendVisibilityChangeEvent(), 100);
      });
  }
}

// function resetAugmentation() {
//   cleanUpAugmentation();
//   setAugmentedFlag(false);
//   runAugmentation();
// }

function loadCss(url) {
  let head = document.getElementsByTagName('head')[0],
    link = document.createElement('link');
  link.type = 'text/css';
  link.rel = 'stylesheet';
  link.href = url;
  head.appendChild(link);
  return link;
}

function startAnalytics() {
  ClientAnalytics.initialize();
}

function listenForSPALocationChanges() {
  const origReplaceState = history.replaceState;
  const hasPathChanged = stateArgs => stateArgs[2] !== location.pathname;

  function delayedResetAugmentation() {
    // setTimeout(() => resetAugmentation(), 10000);
  }

  history.replaceState = function captureReplaceState() {
    const pathChanged = hasPathChanged(arguments);
    origReplaceState.apply(history, arguments); // preserve normal functionality
    if (pathChanged) {
      console.log('[VUP] history.replaceState');
      delayedResetAugmentation();
    }
  };

  const origPushState = history.pushState;
  history.pushState = function capturePushState() {
    const pathChanged = hasPathChanged(arguments);
    origPushState.apply(history, arguments); // preserve normal functionality
    if (pathChanged) {
      console.log('[VUP] history.pushState');
      delayedResetAugmentation();
    }
  };

  window.addEventListener('popstate', () => {
    console.log('[VUP] window.popstate');
    delayedResetAugmentation();
  });
}
